import { useDispatch, useSelector } from 'react-redux';
import { Alert, AlertTitle, Button, ButtonGroup, IconButton, Link, Slide, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import { closeCookieBanner as closeCookieBannerAction, openCookiePreferences as openPreferencesAction } from '../../../features/layoutSlice';
import config from '../../../app/config';

function CookieBanner({ handleCookieSubmit }) {
  const isOpen = useSelector((state) => state.layout.isCookieBannerOpen);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const openCookiePreferences = () => {
    dispatch(openPreferencesAction());
  };
  const close = () => {
    dispatch(closeCookieBannerAction());
  };
  const acceptAllAndSubmit = () => {
    const cookieConsentLocalState = config.cookies.supportedCookies.reduce((acc, cookie) => {
      acc[cookie] = true;
      return acc;
    }, {});
    handleCookieSubmit(cookieConsentLocalState);
    close();
  };

  return (
    <Slide direction="up" in={!!isOpen} mountOnEnter unmountOnExit>
      <Alert
        variant="cookie_banner"
        elevation={12}
        aria-describedby="CookieConsent-description"
        data-testid="cookieBanner"
        action={
          <IconButton aria-label="close" onClick={close}>
            <CloseIcon />
          </IconButton>
        }
        sx={{ py: 2 }}
        icon={false}
      >
        <AlertTitle>{t('cookies.heading', { appName: 'Food Advisor' })}</AlertTitle>
        <Typography id="CookieConsent-description" sx={{ pb: 2 }}>
          {t('cookies.message')}
          <Link to="privacy/cookie">{t('cookies.link')}</Link>
        </Typography>
        <ButtonGroup>
          <Button onClick={openCookiePreferences}>{t('common.actions.show')}</Button>
          <Button variant="contained" onClick={acceptAllAndSubmit} data-testid="acceptAll">
            {t('cookies.actions.acceptAll')}
          </Button>
        </ButtonGroup>
      </Alert>
    </Slide>
  );
}

CookieBanner.propTypes = {
  handleCookieSubmit: propTypes.func.isRequired,
};

export default CookieBanner;
